import { Pin } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import type { LiveUpdate } from "@/lib/mock-data";
import { PriorityBadge } from "./Badges";

function timeOnly(iso: string, locale: string) {
  return new Date(iso).toLocaleTimeString(locale === "fr" ? "fr-FR" : "en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function LiveUpdateCard({ update }: { update: LiveUpdate }) {
  const { locale, t } = useI18n();
  const text = update.text[locale] ?? update.text.fr ?? "";
  return (
    <li className="relative pl-6">
      <span className="absolute left-0 top-2 h-2.5 w-2.5 rounded-full border-2 border-background bg-foreground" />
      <span className="absolute left-[5px] top-5 bottom-[-1.5rem] w-px bg-rule" />
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="font-mono font-semibold text-foreground">{timeOnly(update.timestamp, locale)}</span>
        <PriorityBadge priority={update.priority} />
        {update.pinned && (
          <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-muted-foreground">
            <Pin className="h-3 w-3" /> {t("live.pinned")}
          </span>
        )}
      </div>
      <p className="mt-1.5 text-sm leading-relaxed text-foreground">{text}</p>
    </li>
  );
}
